'use strict';

import React from 'react';
import PropTypes from 'prop-types';

import 'styles/WidgetCount.scss';

const propTypes = {
    id: PropTypes.string,
};

const WidgetCount = (props) => {

    return (
        <div id={props.id} className="widget-count">
            <div className={props.iconName} style={{color:'#fff'}}></div>
            {props.value !== null ? (
                <div className="value">
                    {props.value}
                </div>
            ) : null}
            <div className="unit">{props.unit}</div>
        </div>
    );
};

WidgetCount.propTypes = propTypes;

export default WidgetCount; 